import { Button } from "@/components/ui/button";
import { useLocaleNavigate } from "@/hooks/useLocaleNavigate";
import { useTranslation } from "react-i18next";

interface LimitReachedStateProps {
  nextResetDate?: string;
}

const LimitReachedState = ({ nextResetDate }: LimitReachedStateProps) => {
  const navigate = useLocaleNavigate();
  const { t } = useTranslation();

  const getNextMonday = () => {
    const today = new Date();
    const daysUntilMonday = (8 - today.getDay()) % 7 || 7;
    const nextMonday = new Date(today);
    nextMonday.setDate(today.getDate() + daysUntilMonday);
    return nextMonday.toLocaleDateString("de-DE", {
      weekday: "long",
      day: "numeric",
      month: "long",
    });
  };

  return (
    <div className="flex flex-col items-center justify-center py-16 px-8 border border-border bg-secondary/30">
      <div className="text-center space-y-6 max-w-md">
        <div className="space-y-2">
          <h3 className="text-headline">{t("limitReached.title")}</h3>
          <p className="text-body text-muted-foreground">
            {t("limitReached.subtitle")}
          </p>
        </div>

        <div className="p-4 border border-border bg-background">
          <span className="text-micro block mb-1">{t("limitReached.nextReset")}</span>
          <p className="text-body font-medium">{nextResetDate || getNextMonday()}</p>
        </div>

        <p className="text-caption">
          {t("limitReached.description")}
        </p>

        <Button
          variant="quiet"
          onClick={() => navigate("/onboarding")}
        >
          {t("limitReached.adjustLimit")}
        </Button>
      </div>
    </div>
  );
};

export default LimitReachedState;
